import $ from 'jquery'
import { toolkitUrls } from '@/links'
import { defaultMemoryCache, ajaxCacheWrapper } from './cache'

export { getSuperPage }

function getSuperPage(id, queryParams = {}) {
  let url = `${toolkitUrls.api}/super-pages/${id}`

  return ajaxCacheWrapper(defaultMemoryCache, {
    url,
    method: 'GET',
    dataType: 'json',
    data: $.param(queryParams),
    xhrFields: { withCredentials: true }
  })
}
